import React, { useState, Fragment, useEffect, useContext, useRef } from "react";
import { AppContext } from "../../../components/AppProvider";
import { _API, _CK, _U } from "../../../modules/utils";
import { Modal, Button } from "react-bootstrap";
import { styled } from '@mui/material/styles';
import checkImg from "../../../resources/console/images/icon/6555.svg"
import errorMsgImg from "../../../resources/console/images/icon/errorMsgImg.svg"
import { TextareaAutosize,FormControl,RadioGroup,FormControlLabel,Radio,FormGroup,Checkbox } from "@mui/material";

const BpIcon = styled('span')(({ theme }) => ({
  borderRadius: "50%",
  width: 8,
  height: 8,
  backgroundColor: theme.palette.mode === 'dark' ? '#394b59' : '#f5f8fa',
  '.Mui-focusVisible &': {
    outline: '2px auto rgba(19,124,189,.6)',
    outlineOffset: 2,
  },
  border: "8px solid #dddddd",
  boxSizing:"content-box",
  'input:hover ~ &': {
    backgroundColor: theme.palette.mode === 'dark' ? '#30404d' : '#ebf1f5',
  },
  'input:disabled ~ &': {
    boxShadow: 'none',
    background:
      theme.palette.mode === 'dark' ? 'rgba(57,75,89,.5)' : 'rgba(206,217,224,.5)',
  },
  '& .MuiRadio-root:hover': {
    backgroundColor: "unset"
  }
}));

const BpCheckedIcon = styled(BpIcon)({
  border: "8px solid #7758fa",
  backgroundColor: '#fff',
  boxSizing:"content-box",
  'input:hover ~ &': {
    backgroundColor: '#eee',
  },
});
// Inspired by blueprintjs
function BpRadio(props) {
  return (
    <Radio
      disableRipple
      color="default"
      checkedIcon={<BpCheckedIcon />}
      icon={<BpIcon />}
      sx={{ padding:"0",marginRight:"4px","&:hover": {backgroundColor:"unset"} }}
      {...props}
    />
  );
}
// Inspired by blueprintjs
function BpCheckbox(props) {
  return (
    <Checkbox
      disableRipple
      color="default"
      checkedIcon={<BpCheckedIcon />}
      icon={<BpIcon />}
      inputProps={{ 'aria-label': 'Checkbox demo' }}
      sx={{padding:"0",marginRight:"4px","&:hover": {backgroundColor:"unset"}}}
      {...props}
    />
  );
}
function SurveyModal(props) {
  const { iam, saveAuth } = useContext(AppContext);
  const { consoleCfg } = props;
  const { show, setShow, surveyInfo ,setSurveyInfo} = props;
  const [surveys, setSurveys] = useState([]);
  const [pageNum, setPageNum] = useState(1);
  const [pageTotalCount, setPageTotalCount] = useState(0);
  const [submit, setSubmit] = useState(false);
  const inputRef = useRef([]);
  const lastOpenKeyRef = useRef("");
  const surveyInfoRef = useRef(surveyInfo);

  // 브라우저 네이티브 fullscreen을 유지하려면 window.alert/confirm, swal 같이 top-layer 팝업으로
  // 인식되는 대화상자를 피해야 한다(브라우저가 자동으로 fullscreen 종료시킴).
  // React-Bootstrap Modal은 일반 DOM 요소라 fullscreen을 깨지 않으므로 이걸로 커스텀 confirm/alert 구현.
  const [dialog, setDialog] = useState(null);
  const dialogResolveRef = useRef(null);
  const showDialog = (text, buttons = null) => new Promise((resolve) => {
    dialogResolveRef.current = resolve;
    setDialog({ text, buttons });
  });
  const closeDialog = (result) => {
    const resolve = dialogResolveRef.current;
    dialogResolveRef.current = null;
    setDialog(null);
    if (resolve) resolve(result);
  };

  useEffect(() => {
    surveyInfoRef.current = surveyInfo;
  }, [surveyInfo]);

  useEffect(() => {
    if(surveyInfo?.active === false && !surveyInfo?.show){
      return;
    }
    if (!surveyInfo?.idx || !surveyInfo?.show || !iam?.preregIdx) {
      return;
    }

    const openKey = [
      surveyInfo?.idx,
      iam?.preregIdx,
      surveyInfo?.show ? "1" : "0",
      surveyInfo?.clickStatus || "",
    ].join(":");

    if (lastOpenKeyRef.current === openKey) {
      return;
    }
    lastOpenKeyRef.current = openKey;

    setSurveys([]);
    setPageTotalCount(0);
    setSubmit(false);

    settingSurvey(surveyInfo.idx, {
      clickStatus: surveyInfo?.clickStatus,
    }).catch((error) => {
      console.error("[SurveyModal] settingSurvey failed:", error);
      lastOpenKeyRef.current = "";
    });
  },[surveyInfo, iam?.preregIdx]);

  const openSurvey = async (status,clickStatus,surIdx) => {
    let surveyIdx = 0;
    if(surIdx > 0){
      surveyIdx = surIdx;
    }
    const canUseDirectSurveyIdx = status == 3 && surveyIdx > 0;
    if (canUseDirectSurveyIdx) {
      const surveyData = {
        active : true,
        show : true,
        idx : surveyIdx,
        clickStatus : clickStatus == "click" ? "click" : "",
      }
      setSurveyInfo(surveyData)
      return;
    }
    const req = {
      path: "/v1/event/session/surveys/find/menu/connect/survey",
      data : {
        eventIdx: consoleCfg?.eventIdx,
        sessionIdx: consoleCfg?.sessionIdx,
        status : status,
        surveyIdx : surveyIdx,
      }
    };
    await _API.post(req).then((res) => {
      if(res.data.data.idx > 0){
        const surveyData = {
          active : true,
          show : true,
          idx : res.data.data.idx,
          clickStatus : clickStatus == "click" ? "click" : "",
        }
        setSurveyInfo(surveyData)
      }else{
        if(status == 1){
          showDialog('현재 진행중인 서베이가 없습니다.');
        }
        return;
      }
    });
  }

  const refreshConsoleAccessKey = async () => {
    if (!iam) {
      return _CK.getAuth() || "";
    }

    try {
      const refreshReq = {
        path: "/v1/client/refresh/accessKey",
        data: { iam },
      };
      const res = await _API.post(refreshReq);
      const { accessKey } = res.data || {};

      if (accessKey) {
        _CK.setAuth(accessKey);
        saveAuth && saveAuth(accessKey);
        return accessKey;
      }
    } catch (e) {
      console.error("[SurveyModal] refresh/accessKey failed:", e);
    }

    return _CK.getAuth() || "";
  };

  const shouldRetryWithRefresh = (error) => {
    const errorCode = Number(error?.error);
    const message = `${error?.message || ""}`;

    return (
      errorCode === -4 ||
      errorCode === -5 ||
      message.includes("인증정보") ||
      message.includes("회원 인증 정보를 확인") ||
      message.includes("authorization")
    );
  };

  const loadSurveyDetail = async (surveyIdx, auth, isNoErrorNotify = false) => {
    const req = {
      path: "/v1/event/session/surveys/view",
      auth,
      isNoErrorNotify,
      data: {
        idx : surveyIdx,
        preregIdx : iam?.preregIdx,
        eventIdx : consoleCfg?.eventIdx,
        sessionIdx : consoleCfg?.sessionIdx
      },
    };

    const res = await _API.post(req);
    return res.data;
  };

  const loadSurveyDetailWithAccessKeyRetry = async (surveyIdx) => {
    const currentAccessKey = _CK.getAuth() || "";

    if (currentAccessKey) {
      try {
        return await loadSurveyDetail(surveyIdx, currentAccessKey, true);
      } catch (error) {
        if (!shouldRetryWithRefresh(error)) {
          throw error;
        }
      }
    }

    const refreshedAccessKey = await refreshConsoleAccessKey();

    if (!refreshedAccessKey) {
      throw new Error("서베이 인증 정보를 갱신할 수 없습니다.");
    }

    return loadSurveyDetail(surveyIdx, refreshedAccessKey);
  };

  const settingSurvey = async (surveyIdx, options = {}) => {
    const { clickStatus = "", allowSubmittedOpen = false } = options;
    setSurveys([]);
    setPageTotalCount(0)
    setSubmit(false);
    const result = await loadSurveyDetailWithAccessKeyRetry(surveyIdx);
    const submittedCount = Number(result?.cnt?.cnt || 0);
    const hasSubmitted = submittedCount > 0;

    if (hasSubmitted && !allowSubmittedOpen) {
      if(clickStatus == "click"){
        showDialog("이미 참여하신 서베이입니다.");
      }
      // 같은 openKey가 캐시에 남아있으면 다음 클릭이 useEffect 가드에서 막혀 무반응이 됨.
      // 클릭 재시도 시 alert가 다시 뜨도록 캐시를 비운다.
      lastOpenKeyRef.current = "";
      return;
    }

    if(hasSubmitted){
      setSubmit(true);
    }

    setPageNum(1);
    setSurveys(result?.data);
    setPageTotalCount(result?.data?.pages?.length || 0)
    setShow(true);
  };

  const handleClose = () => {
    lastOpenKeyRef.current = "";
    setShow(false);
  };
  
  const saveSurvey = async (e) => {
    let cnt = 0;
    let nextStep = 0;
    surveys.pages.map((page , i) => {
      if(pageNum == page.order){
        page.questions.map((question , j) => {
          let cnt2 = 0;
          if(question.required == "Y"){
            question.opts.map((answer , k) => {
              if(answer.userValue != false && answer.userValue != null && answer.userValue != ""){
                cnt2++;
              }
            })
            if(cnt2 == 0){
              cnt++;
              setSurveys((o) => {
                let survey = {...o};
                survey.pages[i].questions[j].errorMsg = consoleCfg?.sessionIdx != 1427 ? `필수 응답 질문입니다.` : `This is a required question.(필수 응답 질문입니다.)`;
                return survey;
              })
            }
          }
        })
      }
    })
    if(cnt == 0){
      surveys.pages.map((page , i) => {
        if(pageNum == page.order){
          page.questions.map((question , j) => {
            setSurveys((o) => {
              let survey = {...o};
              delete survey.pages[i].questions[j]["errorMsg"];
              return survey;
            })
          })
        }
      })
      nextStep++;
    }else{
      showDialog(consoleCfg?.sessionIdx != 1427 ? "필수 질문에 응답해주세요." : "Please answer the required question.(필수 질문에 응답해주세요.)");
      return
    }
    
    

    if(nextStep > 0){
      let eventIdx = consoleCfg?.eventIdx;
      let sessionIdx = consoleCfg?.sessionIdx;
      let preregIdx = iam?.preregIdx;
      let surveyIdx = surveys?.idx;
      let array = [];
      let pageOrder = 0;
      surveys?.pages.map((page, i) => {
        page?.questions.map((question, j) => {
          let values = {"preregIdx":preregIdx, "surveyIdx":surveyIdx, "eventIdx":eventIdx, "sessionIdx":sessionIdx, "questionIdx":question.idx};
          if(question.required != "Y" && question?.questionType == 'MULTIPLE' && question?.opts?.filter((o) => o?.userValue != null)?.length <= 0){
            array.push({...values,["optionIdx"] : 0, ["optionLabel"] : null, ["optionValue"] : null});
          }else if(question.required != "Y" && question?.questionType == 'SUBJECT' && question?.opts?.filter((o) => o?.userValue != null)?.length <= 0){
            array.push({...values,["optionIdx"] : 0, ["optionLabel"] : null, ["optionValue"] : null});
          }else{
            question?.opts.map((option, k) => {
              if(question.required == "Y"){
                if(!option.userValue == false && option.userValue != null && option.userValue != ""){
                  array.push(
                    {...values,
                      ["optionIdx"]   : question.questionType == "SUBJECT" ? 0 : option.idx, 
                      ["optionLabel"] : question.questionType == "SUBJECT" ? null : option.label, 
                      ["optionValue"] : option.userValue
                    }
                  );
                }else{
                  if(pageOrder == 0){
                    pageOrder = i+1;
                  }
                }
              }else{
                if(!option.userValue == false && option.userValue != null && option.userValue != ""){
                  array.push(
                    {...values,
                      ["optionIdx"]   : question.questionType == "SUBJECT" ? 0 : option.idx, 
                      ["optionLabel"] : question.questionType == "SUBJECT" ? null : option.label, 
                      ["optionValue"] : option.userValue
                    }
                  );
                }
              }
            })
          }
        })
      })
      
      // 네이티브 window.confirm은 iOS Safari에서 URL바 노출, swal은 브라우저가 popup으로 인식해
      // fullscreen을 자동 종료시킴. React-Bootstrap Modal 기반 커스텀 다이얼로그 사용.
      const confirmed = await showDialog(
        consoleCfg?.sessionIdx != 1427
          ? `서베이를 제출하시겠습니까?\n제출 후에는 답변을 수정하실 수 없습니다.`
          : `Submit the survey?\nYou can't edit your answers after submitting.(서베이를 제출하시겠습니까? 제출 후에는 수정 불가)`,
        consoleCfg?.sessionIdx != 1427 ? ["취소", "제출"] : ["Cancel(취소)", "Submit(제출)"]
      );
      if (confirmed) {
        const req = {
          path: "/v1/event/session/surveys/save",
          data: {
            answers : array
          },
        };
        _API.post(req).then((res) => {
          let result = res.data.result;
          if (result > 0) {
            setSubmit(true)
          }
        });
      }
    }
  };
  
  const nextSurvey = (e,pageNum) => {
    let cnt = 0;
    surveys.pages.map((page , i) => {
      if(pageNum == page.order){
        page.questions.map((question , j) => {
          let cnt2 = 0;
          if(question.required == "Y"){
            question.opts.map((answer , k) => {
              if(answer.userValue != false && answer.userValue != null && answer.userValue != ""){
                cnt2++;
              }
            })
            if(cnt2 == 0){
              cnt++;
              setSurveys((o) => {
                let survey = {...o};
                survey.pages[i].questions[j].errorMsg = `필수 항목입니다.`;
                return survey;
              })
            }else{
              setSurveys((o) => {
                let survey = {...o};
                delete survey.pages[i].questions[j]["errorMsg"];
                return survey;
              })
            }
          }
        })
      }
    })
    if(cnt == 0){
      surveys.pages.map((page , i) => {
        if(pageNum == page.order){
          page.questions.map((question , j) => {
            setSurveys((o) => {
              let survey = {...o};
              delete survey.pages[i].questions[j]["errorMsg"];
              return survey;
            })
          })
        }
      })
      let num = pageNum + 1;
      if(pageNum < pageTotalCount){
        setPageNum(num);
      }
    }else{
      showDialog("필수 질문에 응답해주세요.");
      return
    }
  };
  
  const prevSurvey = (e) => {
    let num = pageNum - 1;
    if(pageNum > 0){
      setPageNum(num);
    }
  };
  useEffect(() => {
    let survey_sub = $(".survey_container .modal_header p");
    let urvey_subH = survey_sub.outerHeight();
    if (urvey_subH > 120) {
      survey_sub.css("font-size", "14px")
    }
  });

  const onReceivedMessage = (e) => {
    _U.parseMessage(e).then((data) => {
      switch (data.code) {
          case "SOCKET-RECEIVED":
              return data.data ? JSON.parse(data.data) : null;
      }
    }).then((data) => {
      if(data?.mode == 'SURVEY_DATA_MENU_CONN'){
      
      }
      if (data?.mode === "SURVEY_OPEN") {
        const nextSurveyIdx = Number(data.idx) || 0;
        const currentSurveyInfo = surveyInfoRef.current;
        if (currentSurveyInfo?.show && currentSurveyInfo?.active && Number(currentSurveyInfo?.idx) === nextSurveyIdx) {
          return;
        }
        openSurvey(3,"click",data.idx)
      } 
      if (data?.mode === "SURVEY_CLOSE") {
        lastOpenKeyRef.current = "";
        setShow(false);
        setSurveyInfo((prev) => ({
          ...prev,
          active: false,
          show: false,
          clickStatus: "",
        }));
      }
      if (data?.mode === "MODAL_POPUP_OPEN") {
        lastOpenKeyRef.current = "";
        setShow(false);
        setSurveyInfo((prev) => ({
          ...prev,
          active: false,
          show: false,
          clickStatus: "",
        }));
      }
      if(data?.mode == 'CONN_DISCONN'){
      
      }
    });
  };

  useEffect(() => {
    window.addEventListener("message", onReceivedMessage);
    return () => {
      window.removeEventListener("message", onReceivedMessage);
    }; 
  }, []);

  // [제거됨] mount 시 BEFORE 응답 완료자에게 "제출완료" confirm 모달 자동 노출하던 로직.
  // 새로고침마다 confirm 모달이 떠 진행서베이 흐름을 가로막아 제거.

  const onSetOpt = (pageIndex, questionIndex, optIndex, value, checked) => {
    setSurveys((o) => {
      let survey = {...o};
      let target = survey?.pages[pageIndex]?.questions[questionIndex];
      if(checked == true){
        if(target?.questionType == 'MULTIPLE' && target?.answerType == 'SINGLE'){
          survey?.pages[pageIndex]?.questions[questionIndex].opts?.map((opt, k) => {
            if(k == optIndex) {
              opt.userValue = value;
            }else{
              delete opt["userValue"];
            }
          })
        }else{
          survey.pages[pageIndex].questions[questionIndex].opts[optIndex].userValue = value;
        }
      }else{
        delete survey.pages[pageIndex].questions[questionIndex].opts[optIndex]["userValue"];
      }
      
      return survey;
    })
  }
  
  return (
    <Fragment>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        className="survey_container"
      >
        <div className="modal_header">
          <div className="modal_header_inner">
            <div className="modal_title" id="survey_title">
              <div dangerouslySetInnerHTML={{ __html: _U.sanitizeHtml(surveys?.title) }}></div>
            </div>
          </div>
          {surveys?.closeBtnUse == 'Y' && (
            <div className="close" onClick={handleClose}></div>
          )}
        </div>
        <div className="m_width_wrap">
          <div className="modal_body">
            {surveys?.topDescriptionShow == 'Y' && (
              <div id="survey_description" className="modal_top_desc">
                <div dangerouslySetInnerHTML={{ __html: _U.sanitizeHtml(surveys?.topDescription) }}></div>
              </div>
            )}
            {submit ? (
              // CSS 미디어쿼리가 여러 겹 중첩되어 있고 각각 다른 height/margin/img 사이즈를 주어
              // 모바일에서 컨텐츠가 화면 밖으로 밀리는 문제가 있었음.
              // viewport 단위 min()으로 인라인 제한을 걸어 PC/모바일/landscape 모두 한 화면에 들어오게 한다.
              <div
                className="submit_comfirm"
                style={{
                  margin: 0,
                  padding: "16px 20px",
                  gap: 12,
                  height: "auto",
                  minHeight: 0,
                }}
              >
                <img
                  src={checkImg}
                  alt="제출완료"
                  style={{ maxHeight: "min(15vh, 100px)", width: "auto" }}
                />
                <p style={{ margin: 0 }}>
                  {consoleCfg?.sessionIdx != 1427 ? '제출이 완료되었습니다. 참여해 주셔서 감사합니다.' : 'Submission complete. Thank you for participating.(제출이 완료되었습니다. 참여해 주셔서 감사합니다.)'}
                </p>
                {consoleCfg.surveyImgUse == 'Y' &&
                  <img
                    style={{
                      display: "block",
                      maxWidth: "40%",
                      maxHeight: "min(25vh, 200px)",
                      width: "auto",
                      objectFit: "contain",
                      margin: "0 auto",
                    }}
                    src={consoleCfg.signedUrlSurveyImg}
                  />
                }
              </div>
            ) : (
              surveys?.pages && surveys?.pages.map((page, i) => {
                return (
                  page.order == pageNum && (
                    <div key={i}>
                      {(page.titleShow == "Y" || page.descriptionShow == 'Y') && (
                        <div className="modal_page_desc">
                          {page.titleShow == 'Y' && (
                            <h5 dangerouslySetInnerHTML={{ __html: _U.sanitizeHtml(page.title) }}></h5>
                          )}
                          {page.descriptionShow == 'Y' && (
                            <div style={{ marginTop: "10px" }}>
                              <div dangerouslySetInnerHTML={{ __html: _U.sanitizeHtml(page.description) }}></div>
                            </div>
                          )}
                        </div>
                      )}
                      {page.questions && page.questions.map((question, j) => {
                        return (
                          <div key={j} className="form-group">
                            <div className="survey_question">
                              {question.question}{question.required == "Y" && (<span style={{ color: "red" }}>*</span>)}
                            </div>
                            <div className="survey_choice">
                              {question.questionType == "SUBJECT" ? (
                                <TextareaAutosize
                                  aria-label="empty textarea"
                                  ref={(el => (inputRef.current[i] = el))}
                                  value={question.opts[0]?.userValue || ''}
                                  style={{ width: "100%", height: 100, borderLeft: "1px solid #111" }}
                                  maxRows={4}
                                  onChange={(e) => onSetOpt(i, j, 0, e.target.value, true)}
                                />
                              ) : (
                                <>
                                  {question.answerType == 'SINGLE' && (
                                    <FormControl sx={{ marginLeft: "0", "& .MuiTypography-root": { wordBreak: "break-all" } }}>
                                      <RadioGroup
                                        aria-labelledby="demo-radio-buttons-group-label"
                                        defaultValue=""
                                        name="radio-buttons-group"
                                      >
                                        {question.opts && question.opts.map((option, k) => {
                                          return (
                                            <FormControlLabel
                                              key={k}
                                              value={option.value}
                                              sx={{ marginLeft: "0", marginBottom: "20px", alignItems: "flex-start" }}
                                              control={<BpRadio onChange={(e) => onSetOpt(i, j, k, e.target.value, e.target.checked)} checked={option.value == option.userValue} />}
                                              label={option.label}
                                            />
                                          )
                                        })}
                                      </RadioGroup>
                                    </FormControl>
                                  )}
                                
                                  {question.answerType == 'MULTI' && (
                                    <FormGroup>
                                      {question.opts && question.opts.map((option, k) => {
                                        return (
                                          <FormControlLabel
                                            key={k}
                                            sx={{ marginLeft: "0", marginBottom: "20px", alignItems: "flex-start" }}
                                            control={<BpCheckbox onChange={(e) => onSetOpt(i, j, k, e.target.value, e.target.checked)} checked={option.value == option.userValue} />}
                                            value={option.value}
                                            label={option.label}
                                          />
                                        )
                                      }
                                      )}
                                    </FormGroup>
                                  )}
                                </>
                              )}
                            </div>
                            {question.errorMsg != false && question.errorMsg != null && question.errorMsg != "" &&
                              <div className="errorMsg"><img src={errorMsgImg} /><span>{question.errorMsg}</span></div>
                            }
                          </div>
                        )
                      })}
                      {pageTotalCount == pageNum &&
                        <div className="modal_btm_desc" style={{ padding: '20px 30px' }}>
                          <div dangerouslySetInnerHTML={{ __html: _U.sanitizeHtml(surveys?.bottomDescription) }}></div>
                        </div>
                      }
                    </div>
                  )
                )
              })
            )}
            <div className="modal_footer m_width_modal_footer">
              {!submit && pageNum > 1 && (<Button onClick={(e) => prevSurvey(e)}>이전</Button>)}
              {submit ? (<Button style={{ marginLeft: "auto" }} onClick={handleClose}>확인</Button>)
              : pageTotalCount > pageNum ?
                (<Button style={{ marginLeft: "auto" }} onClick={(e) => nextSurvey(e, pageNum)}>다음</Button>)
              : (<Button style={{ marginLeft: "auto" }} onClick={(e) => saveSurvey(e, pageNum)}>{consoleCfg?.sessionIdx != 1427 ? '제출하기' : 'Submit (제출하기)'}</Button>)
              }
            </div>
          </div>
        </div>
        
        <div className="modal_body">
          {surveys?.topDescriptionShow == 'Y' && (
            <div id="survey_description" className="modal_top_desc modal_top_desc_pc_mobile">
              <div dangerouslySetInnerHTML={{ __html: _U.sanitizeHtml(surveys?.topDescription) }}></div>
            </div>
          )}
          {submit ? (
            <>
              <div
                className="submit_comfirm"
                style={{
                  margin: 0,
                  padding: "16px 20px",
                  gap: 12,
                  height: "auto",
                  minHeight: 0,
                }}
              >
                <img
                  src={checkImg}
                  alt="제출완료"
                  style={{ maxHeight: "min(15vh, 100px)", width: "auto" }}
                />
                <p style={{ margin: 0 }}>
                  {consoleCfg?.sessionIdx != 1427 ? '제출이 완료되었습니다. 참여해 주셔서 감사합니다.' : 'Submission complete. Thank you for participating.(제출이 완료되었습니다. 참여해 주셔서 감사합니다.)'}
                </p>
                {consoleCfg.surveyImgUse == 'Y' &&
                  <img
                    style={{
                      display: "block",
                      maxWidth: "40%",
                      maxHeight: "min(25vh, 200px)",
                      width: "auto",
                      objectFit: "contain",
                      margin: "0 auto",
                    }}
                    src={consoleCfg.signedUrlSurveyImg}
                  />
                }
              </div>
            </>
          ) : (
            <>
              {surveys?.pages && surveys?.pages.map((page, i) => {
                return (
                  page.order == pageNum && (
                    <div key={i}>
                      {(page.titleShow == "Y" || page.descriptionShow == 'Y') && (
                        <div className="modal_page_desc">
                          {page.titleShow == 'Y' && (
                            <h5 dangerouslySetInnerHTML={{ __html: _U.sanitizeHtml(page.title) }}></h5>
                          )}
                          {page.descriptionShow == 'Y' && (
                            <div style={{ marginTop: "10px" }}>
                              <div dangerouslySetInnerHTML={{ __html: _U.sanitizeHtml(page.description) }}></div>
                            </div>
                          )}
                        </div>
                      )}
                      {page.questions && page.questions.map((question, j) => {
                        return (
                          <div key={j} className="form-group">
                            <div className="survey_question">
                              {question.question}{question.required == "Y" && (<span style={{ color: "red" }}>*</span>)}
                            </div>
                            <div className="survey_choice">
                              {question.questionType == "SUBJECT" ? (
                                <TextareaAutosize
                                  aria-label="empty textarea"
                                  value={question.opts[0]?.userValue || ''}
                                  style={{ width: "100%", borderLeft: "1px solid #111", resize: "both" }}
                                  minRows={4}
                                  maxRows={6}
                                  onChange={(e) => onSetOpt(i, j, 0, e.target.value, true)}
                                />
                              ) : (
                                <>
                                  {question.answerType == 'SINGLE' && (
                                    <FormControl sx={{ marginLeft: "0", "& .MuiFormControlLabel-root .MuiFormControlLabel-label": { wordBreak: "break-all" } }}>
                                      <RadioGroup
                                        aria-labelledby="demo-radio-buttons-group-label"
                                        defaultValue=""
                                        name="radio-buttons-group"
                                      >
                                        {question.opts && question.opts.map((option, k) => {
                                          return (
                                            <FormControlLabel
                                              key={k}
                                              value={option.value}
                                              sx={{ marginLeft: "0", marginBottom: "20px", alignItems: "flex-start" }}
                                              control={<BpRadio onChange={(e) => onSetOpt(i, j, k, e.target.value, e.target.checked)} checked={option.value == option.userValue} />}
                                              label={option.label}
                                            />
                                          )
                                        })}
                                      </RadioGroup>
                                    </FormControl>
                                  )}
                                  {question.answerType == 'MULTI' && (
                                    <FormGroup>
                                      {question.opts && question.opts.map((option, k) => {
                                        return (
                                          <FormControlLabel
                                            key={k}
                                            sx={{ marginLeft: "0", marginBottom: "20px", alignItems: "flex-start" }}
                                            control={<BpCheckbox onChange={(e) => onSetOpt(i, j, k, e.target.value, e.target.checked)} checked={option.value == option.userValue} />}
                                            value={option.value}
                                            label={option.label}
                                          />
                                        )
                                      }
                                      )}
                                    </FormGroup>
                                  )}
                                </>
                              )}
                            </div>
                            {question.errorMsg != false && question.errorMsg != null && question.errorMsg != "" &&
                              <div className="errorMsg"><img src={errorMsgImg} /><span>{question.errorMsg}</span></div>
                            }
                          </div>
                        )
                      })}
                      {pageTotalCount == pageNum &&
                        <div className="modal_btm_desc" style={{ padding: '20px 30px' }}>
                          <div dangerouslySetInnerHTML={{ __html: _U.sanitizeHtml(surveys?.bottomDescription) }}></div>
                        </div>
                      }
                    </div>
                  )
                )
              })}
            </>
          )}
        </div>
        <div className="modal_footer">
          {!submit && pageNum > 1 && (<Button onClick={(e) => prevSurvey(e)}>이전</Button>)}
          
          {submit ? (<Button style={{ marginLeft: "auto" }} onClick={handleClose}>확인</Button>)
          : pageTotalCount > pageNum ?
            (<Button style={{ marginLeft: "auto" }} onClick={(e) => nextSurvey(e, pageNum)}>다음</Button>)
          : (<Button style={{ marginLeft: "auto" }} onClick={(e) => saveSurvey(e, pageNum)}>{consoleCfg?.sessionIdx != 1427 ? '제출하기' : 'Submit (제출하기) '}</Button>)
          }
        </div>
      </Modal>
      {/* 커스텀 confirm/alert 다이얼로그 — window.alert/confirm/swal 대체 (브라우저 fullscreen 유지용).
          - survey_container 클래스는 기존 서베이 메인 모달 전용 (전체화면 크기) 이므로 붙이지 않음.
          - fullscreen 상태에서 video_con(z-index:9998) 뒤로 가려지지 않도록 전용 z-index boost 규칙을 인라인 삽입. */}
      <style>{`
        .survey_inline_dialog.modal { z-index: 10002; }
        body.css-fullscreen-active .survey_inline_dialog.modal { z-index: 10002 !important; }
      `}</style>
      <Modal
        show={!!dialog}
        onHide={() => closeDialog(false)}
        centered
        backdrop="static"
        size="sm"
        className="survey_inline_dialog"
      >
        <Modal.Body style={{ padding: "28px 20px 16px", textAlign: "center" }}>
          <div
            style={{
              whiteSpace: "pre-wrap",
              fontSize: 15,
              lineHeight: 1.6,
              color: "#1a1a1a",
              wordBreak: "keep-all",
            }}
          >
            {dialog?.text}
          </div>
        </Modal.Body>
        <Modal.Footer
          style={{
            display: "flex",
            justifyContent: "center",
            gap: 8,
            padding: "10px 16px 16px",
            borderTop: "1px solid #eee",
          }}
        >
          {dialog?.buttons && dialog.buttons.length >= 2 ? (
            <>
              <Button variant="secondary" onClick={() => closeDialog(false)}>
                {dialog.buttons[0]}
              </Button>
              <Button variant="primary" onClick={() => closeDialog(true)}>
                {dialog.buttons[1]}
              </Button>
            </>
          ) : (
            <Button variant="primary" onClick={() => closeDialog(true)}>
              확인
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
}

export default SurveyModal;
